import { Icon, Tooltip } from '@chakra-ui/react';
import { AlertSquare, CheckCircle, HelpSquare, Hourglass03 } from '@untitled-ui/icons-react';
import { useTranslation } from 'react-i18next';

type DocumentStatusIconProps = {
  notTouched: boolean;
  hasErrors: boolean;
  documentStatus: boolean | undefined;
  hasDocument?: boolean;
  isStep1?: boolean;
  currentStatus?: number;
};

const DocumentStatusIcon = ({ notTouched, hasErrors, documentStatus, hasDocument = true, isStep1 = false, currentStatus }: DocumentStatusIconProps) => {
  const { t } = useTranslation();

  const isPoa = hasDocument !== undefined && isStep1 !== undefined;
  const showSubmitted = isPoa ? notTouched && hasDocument && currentStatus !== 100 : notTouched;

  if (showSubmitted) {
    return (
      <Tooltip label={t('workshop_verification_request:icon.submitted')} placement="right" shouldWrapChildren isDisabled={isPoa && isStep1}>
        <Icon as={AlertSquare} ml={2} color="blue.500" fontSize={23} />
      </Tooltip>
    );
  }

  if (hasErrors) {
    return (
      <Tooltip label={t('workshop_verification_request:icon.error')} placement="right" shouldWrapChildren>
        <Icon as={HelpSquare} ml={2} color="orange.500" fontSize={23} />
      </Tooltip>
    );
  }

  if (documentStatus) {
    return (
      <Tooltip label={t('workshop_verification_request:icon.success')} placement="right" shouldWrapChildren>
        <Icon as={CheckCircle} ml={2} color="green.500" fontSize={23} />
      </Tooltip>
    );
  }

  return (
    <Tooltip label={t('workshop_verification_request:icon.pending')} placement="right" shouldWrapChildren>
      <Icon as={Hourglass03} ml={2} fontSize={23} />
    </Tooltip>
  );
};

export default DocumentStatusIcon;
